'use client'
export const APIURLBASE = "https://www.rudrasofttech.com/api/";
export const APIURLS = {
    userWebsite: `${APIURLBASE}userwebsite`,
    userWebsiteTheme: `${APIURLBASE}userwebsitetheme`,
    userWebsiteTemplates: `${APIURLBASE}userwebsite/templates`,
    userWebsiteHtmlPage: `${APIURLBASE}userwebsite/htmlpage`,
    // Add more endpoints as needed
};
